<template>
  <v-flex xs12 px-3 style="padding-top: 10px !important; width: 100vw;" class="forecastContainer">
    <v-flex xs12 v-if="showBreadCrumb || showButtons">
      <v-btn @click="gotoFrontPage" style="width: 50px;" class="breadCrumb" v-if="showBreadCrumb">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn @click="gotoForecast" class="breadCrumb" v-if="showBreadCrumb">
        Forecast
      </v-btn>
      <v-btn @click="selectSupplier(currentSupplier)" class="breadCrumb" v-if="showBreadCrumb && isSupplierSelected">
        {{ currentSupplier.name }}
      </v-btn>
      <v-btn @click="selectField(currentField)" class="breadCrumb" v-if="showBreadCrumb && isFieldSelected">
        {{ currentField.address.name }}
      </v-btn>
      <div style="display: inline; float: right;" v-if="showButtons">
        <v-btn @click="printFieldData()" class="btnPrintReport" style="margin-right: 50px !important;" v-if="isShowingFields">Print</v-btn>
        <v-btn @click="doNotShowAllFields" class="btnToggleFilter" :disabled="!isShowingAllFields" v-if="isShowingFields">Selected fields</v-btn>
        <v-btn @click="doShowAllFields" class="btnToggleFilter" :disabled="isShowingAllFields" v-if="isShowingFields">All fields</v-btn>
        <v-btn @click="showAllFamilies = !showAllFamilies" class="btnToggleFilter" v-if="isShowingForecast">
          {{ showAllFamilies ? 'Done' : 'Add family' }}
        </v-btn>
      </div>
      <div style="height: 10px;"></div>
    </v-flex>
    <v-snackbar v-model="snackbar" :timeout='2000' top>{{ snackbarMessage }}</v-snackbar>
    <v-container fluid pa-0 v-show="showSupplierList">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <v-flex xs12 v-for="(supplier, i) in suppliers" :key="i" :style="'height: ' + Math.min(20, Math.max(6, 60 / suppliers.length)) + 'vh; min-height: 5vh !important; margin-bottom: ' + (Math.max(0.5, 8 / suppliers.length)) + 'vh !important;'" class="supplierButton">
            <v-btn @click="selectSupplier(supplier)" :style="'width: 100%; height: ' + Math.min(20, Math.max(6, 60 / suppliers.length)) + 'vh !important; min-height: 5vh !important; max-height: 30vh !important; font-size: ' + Math.min(Math.max(50 - (5 * suppliers.length), 12), 20) + 'pt !important;'">{{ supplier.name }}</v-btn>
          </v-flex>
          <div style="padding-top: 20vh; width: 100%; text-align: center; font-size: 20px;" v-show="suppliers.length === 0">No suppliers found</div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="currentSupplier && !currentField">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto; width: 100%;" v-if="currentSupplier && supplierFieldSummaryReady && supplierFieldSummaryData.length && !currentField">
          <v-data-table :headers="supplierFieldSummaryHeader" :items="filteredSupplierFieldSummaryData" hide-actions class="forecastTable">
            <template v-slot:items="props">
              <tr @click="props.item.type === 'field' && editCategoryFamilies ? selectField(props.item.field) : null" :class="(props.item.type === 'field' && editCategoryFamilies ? 'selectable' : '') + ' supplierFields' + (props.item.type === 'total' ? ' total' : '')">
                <td class="text-xs-left amount">
                  <div v-if="props.item.type === 'field'">{{ props.item.field.address.name }}</div>
                  <div v-if="props.item.type === 'total'">Total</div>
                </td>
                <td class="text-xs-left amount" style="width: 50px;">
                  <div v-if="props.item.type === 'field' && props.item.planting">{{ props.item.planting.year }}</div>
                </td>
                <td class="text-xs-right amount" style="width: 110px; padding-right: 25px !important;">
                  <div class="fieldSummaryValue" v-if="'field'.includes(props.item.type) && props.item.plantAge">{{ props.item.plantAge + ' yr' }}</div>
                </td>
                <td class="text-xs-right amount" style="width: 120px; padding-right: 25px !important;">
                  <div class="fieldSummaryValue" v-if="props.item.planting && props.item.type === 'field'">{{ props.item.planting.size.toFixed(2) + ' ha'}}</div>
                  <div class="fieldSummaryValue" v-if="'total'.includes(props.item.type)">{{ props.item.size ? props.item.size.toFixed(2) + ' ha' : ''}}</div>
                </td>
                <td class="text-xs-right amount" style="width: 110px;">
                  <div class="fieldSummaryValue" v-if="props.item.type === 'field' && props.item.planting">{{ props.item.planting.amount.toLocaleString() }}</div>
                  <div class="fieldSummaryValue" v-if="'total'.includes(props.item.type)">{{ props.item.amount ? props.item.amount.toLocaleString() : '' }}</div>
                </td>
                <td class="text-xs-right amount" style="width: 110px; padding-right: 20px !important;">
                  <div class="fieldSummaryValue" v-if="'field|total'.includes(props.item.type) && props.item.amountRemaining">{{ props.item.amountRemaining.toLocaleString() }}</div>
                </td>
                <td class="text-xs-right amount" style="width: 110px; padding-right: 15px !important;">
                  <div class="fieldSummaryValue" v-if="'field|total'.includes(props.item.type)">{{ props.item.amountForecast ? props.item.amountForecast.toLocaleString() : '' }}</div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="currentField && editCategoryFamilies">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto; width: 100%;">
          <v-data-table :headers="fieldForecastHeader" :items="fieldForecastData" hide-actions class="forecastTable" v-if="fieldForecastData && fieldForecastData.length">
            <template v-slot:items="props">
              <tr :class="(props.item.type === 'TOTAL' ? 'total' : '') + (props.item.added ? ' addedFamily' : '')" v-if="showForecastData(props.item) || showAllFamilies">
                <!-- Family name -->
                <td class="text-xs-left amount">
                  <div v-if="props.item.type === 'LINE'" style="cursor: pointer;">
                    {{ props.item.family.displayLabel }}
                  </div>
                  <div v-if="props.item.type === 'TOTAL'" class="subTotal">
                    Total
                  </div>
                </td>

                <!-- Forecast amount -->
                <td class="text-xs-right amount" v-if="props.item.type === 'LINE'" style="width: 130px !important; padding-right: 5px !important;"><div style="padding: 0 10px; display: inline-block;">{{ props.item.forecastAmount.toLocaleString() }}</div></td>
                <td class="text-xs-right amount" v-if="props.item.type === 'TOTAL'" style="width: 130px !important; padding-right: 5px !important;"><div style="padding: 0 10px; display: inline-block;">{{ props.item.removed ? '' : props.item.forecastAmount.toLocaleString() }}</div><div class="utilization">{{ getUtilization(props.item.forecastAmount) }}</div></td>

                <!-- Forecast distribution % -->
                <td class="text-xs-right amount" style="width: 90px !important; padding-right: 15px !important;" v-if="props.item.type === 'LINE'"><div style="padding: 0 30px 0 30px;">{{ props.item.removed ? '' : props.item.forecastDistribution.toFixed(1) + '%' }}</div></td>
                <td class="text-xs-right amount" style="width: 90px !important; padding-right: 15px !important;" v-if="props.item.type === 'TOTAL'"><div style="padding: 0 30px 0 30px; display: inline-block;">100.0%</div></td>

                <!-- Amount -->
                <td class="text-xs-right amount" v-if="props.item.type === 'LINE'" style="width: 130px !important; padding-right: 5px !important;" @click="props.item.removed ? null : createOrEditForecastOverride(props.item)"><div style="padding: 0 10px; display: inline-block;" :class="(Number(activeProductionName) === fieldForecastData[0].year ? 'selectable' : '') + (props.item.override && props.item.forecastAmount ? ' forecastAdjustment' : '')">{{ props.item.removed ? '' : props.item.amount.toLocaleString() }}</div></td>
                <td class="text-xs-right amount" v-if="props.item.type === 'TOTAL'" style="width: 130px !important; padding-right: 5px !important;"><div @click="createOrEditForecastTotalOverride(props.item)" style="padding: 0 10px; display: inline-block;" :class="(Number(activeProductionName) === fieldForecastData[0].year ? 'selectable' : '') + (props.item.override ? ' forecastAdjustment' : '')">{{ props.item.amount != null ? props.item.amount.toLocaleString() : '' }}</div><div @click="createOrEditForecastTotalOverride(props.item, 'PCT')" :class="'utilization ' + (Number(activeProductionName) === fieldForecastData[0].year ? 'selectable' : '')">{{ getUtilization(props.item.amount) }}</div></td>

                <!-- Distribution % -->
                <td class="text-xs-right amount" style="width: 90px !important; padding-right: 15px !important;" v-if="props.item.type === 'LINE'"><div style="padding: 0 10px;">{{ props.item.removed ? '' : props.item.distribution.toFixed(1) + '%' }}</div></td>
                <td class="text-xs-right amount" style="width: 90px !important; padding-right: 15px !important;" v-if="props.item.type === 'TOTAL'"><div style="padding: 0 10px; display: inline-block;">100.0%</div></td>

                <!-- Action -->
                <td class="text-xs-right amount" style="width: 50px !important; padding-right: 5px !important;" v-if="props.item.type === 'LINE'">
                  <div style="padding: 0 5px;"><v-icon v-if="canRemoveFamily(props.item)" style="font-size: 20px;" @click="removeFamily(props.item)" title="Remove forecast">delete</v-icon></div>
                  <div style="padding: 0 5px;"><v-icon v-if="canRestoreFamily(props.item)" style="font-size: 20px; color: #B0B0B0;" @click="restoreFamily(props.item)" title="Restore forecast">restore_from_trash</v-icon></div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-dialog v-model="forecastOverrideDialog" width="500" content-class="forecastOverrideDialog" persistent v-if="forecastOverrideDialog">
          <v-card pa-5>
            <v-card-title class="headline">Override forecast for {{ forecastOverride.family.displayLabel }}</v-card-title>
            <v-card-text style="padding: 20px 80px;">
              <table style="width: 100%;">
                <tr>
                  <td style="width: 100px;"><v-label>Amount</v-label></td>
                  <td style="padding-right: 30px; padding-top: 5px;">
                    <v-text-field class="alignRight" color="teal" v-model="forecastOverride.amount" autocomplete="offit" style="max-width: 70px;"/>
                  </td>
                </tr>
              </table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="saveForecastOverride" :disabled="saveForecastOverrideButtonDisabled" class="bw-3">Save</v-btn>
              <div style="width: 10px;" v-if="forecastOverrideDeletable"></div>
              <v-btn flat @click="deleteForecastOverride" class="bw-3" v-if="forecastOverrideDeletable">Delete</v-btn>
              <div style="width: 10px;"></div>
              <v-btn flat @click="cancelForecastOverride" class="bw-3">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="forecastTotalOverrideDialog" width="500" content-class="forecastTotalOverrideDialog" persistent v-if="forecastTotalOverrideDialog">
          <v-card pa-5>
            <v-card-title class="headline">Override forecast total</v-card-title>
            <v-card-text style="padding: 20px 80px;">
              <table style="width: 100%;">
                <tr>
                  <td style="width: 50px; padding-right: 50px;"><v-label>{{ forecastTotalOverrideMode === 'PCT' ? 'Percentage' : 'Amount' }}</v-label></td>
                  <td style="padding-right: 30px; padding-top: 5px;">
                    <table>
                      <tr>
                        <td style="width: 70px;" v-if="forecastTotalOverrideMode === 'AMOUNT'">
                          <v-text-field class="alignRight" color="teal" v-model="forecastTotalOverride.amount" autocomplete="offit"/>
                        </td>
                        <td v-if="forecastTotalOverrideMode === 'PCT'">
                          <v-text-field class="alignRight" color="teal" v-model="forecastTotalOverride.pct" autocomplete="offit" style="max-width: 60px;"/>
                        </td>
                        <td v-if="forecastTotalOverrideMode === 'PCT'" style="padding-top: 3px; padding-left: 5px; vertical-align: top;">%</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="saveForecastTotalOverride" :disabled="saveForecastTotalOverrideButtonDisabled" class="bw-3">Save</v-btn>
              <div style="width: 10px;" v-if="forecastTotalOverrideDeletable"></div>
              <v-btn flat @click="deleteForecastTotalOverride" class="bw-3" v-if="forecastTotalOverrideDeletable">Delete</v-btn>
              <div style="width: 10px;"></div>
              <v-btn flat @click="cancelForecastTotalOverride" class="bw-3">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import ErrorDialog from '../components/ErrorDialog'
import NumberUtil from '@/assets/javascript/numberutil'
import axios from 'axios'

export default {
  name: 'Forecast',
  components: { Panel, PanelColumn, ErrorDialog },
  props: {
    hideBreadCrumb: Boolean,
    hideButtons: Boolean,
    editCategoryFamilies: Boolean
  },
  data () {
    return {
      suppliers: [],
      currentSupplier: null,
      currentField: null,
      supplierFieldSummaryReady: false,
      supplierFieldSummaryData: [],
      supplierForecastDatas: null,
      supplierProductionForecastFoundations: [],
      fieldSummaryReady: false,
      fieldSummary: null,
      fieldProductionForecastFoundations: [],
      fieldProductionCategoryForecastFoundations: [],
      fieldPlanting: null,
      fieldForecastData: null,
      forecastOverrideDialog: false,
      forecastOverride: null,
      forecastOverrideDeletable: false,
      forecastTotalOverrideDialog: false,
      forecastTotalOverride: null,
      forecastTotalOverrideMode: null,
      forecastTotalOverrideDeletable: false,
      showAllFields: false,
      showAllFamilies: false,
      supplierFieldSummaryHeader: [
        { text: 'Field', value: 'field.address.name', sortable: false, align: 'left' },
        { text: 'Year', value: 'planting.year', sortable: false, align: 'center' },
        { text: 'Tree age', value: 'plantAge', sortable: false, align: 'right' },
        { text: 'Size  ', value: 'planting.size', sortable: false, align: 'center' },
        { text: 'Planted', value: 'planting.amount', sortable: false, align: 'right' },
        { text: 'Remaining', value: 'amountRemaining', sortable: false, align: 'right' },
        { text: 'Forecast', value: 'amountForecast', sortable: false, align: 'right' }
      ],
      fieldForecastHeader: [
        { text: 'Category family', sortable: false, align: 'left' },
        { text: 'Forecast', sortable: false, align: 'right' },
        { text: '%', sortable: false, align: 'center' },
        { text: 'Amount', sortable: false, align: 'right' },
        { text: '%', sortable: false, align: 'center' },
        { text: '', sortable: false, align: 'left' }
      ],
      snackbar: false,
      snackbarMessage: '',
      updateCounter: 1
    }
  },
  created: function () {
    this.gotoForecast()
  },
  computed: {
    showBreadCrumb: function () {
      return !(this.hideBreadCrumb && this.hideBreadCrumb === true)
    },
    showButtons: function () {
      return !(this.hideButtons && this.hideButtons === true)
    },
    isEditCategoryFamilies: function () {
      return this.editCategoryFamilies
    },
    showSupplierList: function () {
      return !this.isSupplierSelected
    },
    isSupplierSelected: function () {
      return this.currentSupplier
    },
    isFieldSelected: function () {
      return this.currentField
    },
    isShowingFields: function () {
      return this.currentSupplier && !this.currentField
    },
    isShowingAllFields: function () {
      return this.showAllFields
    },
    isShowingForecast: function () {
      return this.currentSupplier && this.currentField
    },
    filteredSupplierFieldSummaryData: function () {
      if (!this.supplierFieldSummaryData || this.supplierFieldSummaryData.length === 0) {
        return []
      }

      let minTreeAge = this.currentSupplier.minTreeAgeForHarvest ? this.currentSupplier.minTreeAgeForHarvest : 0

      let totalSize = 0
      let totalAmountRemaining = 0
      let totalAmount = 0
      let totalAmountForecast = 0

      let supplierFieldSummaryData = []
      for (let fieldSummary of this.supplierFieldSummaryData) {
        if (fieldSummary.field.inactive) {
          continue
        }
        if (!this.showAllFields && fieldSummary.plantAge < minTreeAge) {
          continue
        }

        if (fieldSummary.planting) {
          totalSize += fieldSummary.planting.size
          totalAmount += fieldSummary.planting.amount
        }
        totalAmountRemaining += fieldSummary.amountRemaining
        totalAmountForecast += fieldSummary.amountForecast

        supplierFieldSummaryData.push({
          type: 'field',
          field: fieldSummary.field,
          planting: fieldSummary.planting,
          plantAge: fieldSummary.plantAge,
          fieldAge: fieldSummary.fieldAge,
          amountRemaining: fieldSummary.amountRemaining,
          amountForecast: fieldSummary.amountForecast
        })
      }

      // Add total
      supplierFieldSummaryData.push({
        type: 'total',
        field: '',
        amount: totalAmount,
        amountPerHa: totalAmount ? Math.round(totalAmount / totalSize) : null,
        size: totalSize,
        amountRemaining: totalAmountRemaining,
        amountForecast: totalAmountForecast
      })

      return supplierFieldSummaryData
    },
    hasActiveProduction: function () {
      return this.$store.getters['session/hasActiveProduction']
    },
    activeProductionName: function () {
      return this.hasActiveProduction ? this.$store.getters['session/getActiveProduction'].name : ''
    },
    saveForecastOverrideButtonDisabled () {
      if (this.forecastOverride) {
        if (this.forecastOverride.amount) {
          return !NumberUtil.isZeroOrPositiveInteger(this.forecastOverride.amount)
        }
      }
      return true
    },
    saveForecastTotalOverrideButtonDisabled () {
      if (this.forecastTotalOverride) {
        if (this.forecastTotalOverrideMode === 'AMOUNT') {
          if (this.forecastTotalOverride.amount) {
            return !NumberUtil.isZeroOrPositiveInteger(this.forecastTotalOverride.amount)
          }
        } else if (this.forecastTotalOverrideMode === 'PCT') {
          if (this.forecastTotalOverride.pct) {
            try {
              let pct = parseFloat(this.forecastTotalOverride.pct)
              return pct < 0 || pct > 100
            } catch (e) {
            }
          }
        }
      }
      return true
    }
  },
  methods: {
    gotoFrontPage () {
      this.$parent.$parent.gotoHome()
    },
    gotoForecast () {
      this.currentSupplier = null
      this.currentField = null
      this.loadSuppliers()
    },
    async loadSuppliers () {
      this.suppliers = []
      await axios.get('/backend/rest/supplier/forecast')
        .then(response => {
          this.suppliers = response.data
        })
    },
    selectSupplier (supplier) {
      this.$emit('supplierSelect', supplier)
      this.showAllFields = false
      this.currentField = null
      this.currentSupplier = supplier
      // this.loadFields()
      this.loadSupplierFieldSummary()
    },
    doShowAllFields () {
      this.showAllFields = true
    },
    doNotShowAllFields () {
      this.showAllFields = false
    },
    async loadSupplierFieldSummary () {
      this.supplierFieldSummaryReady = false
      this.supplierFieldSummaryData = []
      this.supplierForecastDatas = []
      this.supplierProductionForecastFoundations = []
      await axios.get('/backend/rest/supplier/summary/' + this.currentSupplier.id)
        .then(response => {
          this.supplierFieldSummaryData = []
          let supplierFieldSummary = response.data
          if (supplierFieldSummary && supplierFieldSummary.fieldSummaries && supplierFieldSummary.fieldSummaries.length) {
            let fieldSummaries = supplierFieldSummary.fieldSummaries
            fieldSummaries.sort(function (s1, s2) {
              let res = s2.plantAge - s1.plantAge
              if (res === 0) {
                res = s1.field.id - s2.field.id
              }
              return res
            })

            for (let fieldSummary of fieldSummaries) {
              let sfsData = {
                type: 'field',
                field: fieldSummary.field,
                planting: fieldSummary.planting,
                plantAge: fieldSummary.plantAge,
                fieldAge: fieldSummary.fieldAge,
                amountRemaining: fieldSummary.amountRemaining,
                amountForecast: 0
              }
              if (supplierFieldSummary.supplierForecasts && supplierFieldSummary.supplierForecasts.length && supplierFieldSummary.supplierForecasts[0].year === Number(this.activeProductionName)) {
                let supplierForecast = supplierFieldSummary.supplierForecasts[0]
                if (supplierForecast.forecastFoundations && supplierForecast.forecastFoundations.length) {
                  for (let forecastFoundation of supplierForecast.forecastFoundations) {
                    if (forecastFoundation.field && forecastFoundation.field.id === fieldSummary.field.id && forecastFoundation.amounts) {
                      for (let key in forecastFoundation.amounts) {
                        let amount = forecastFoundation.amounts[key]
                        if (amount) {
                          sfsData.amountForecast += amount
                        }
                      }
                    }
                  }
                }
              }
              this.supplierFieldSummaryData.push(sfsData)
            }
          }

          if (supplierFieldSummary && supplierFieldSummary.supplierForecasts && supplierFieldSummary.supplierForecasts.length) {
            for (let supplierForecast of supplierFieldSummary.supplierForecasts) {
              if (supplierForecast.families) {
                let supplierForecastData = []
                let totalAmount = 0
                for (let family of supplierForecast.families) {
                  let amount = Math.round(supplierForecast.amounts[family.id])
                  supplierForecastData.push({
                    year: supplierForecast.year,
                    type: 'LINE',
                    family: family,
                    amount: amount
                  })

                  totalAmount += amount

                  // Fill in the expanded lines
                  for (let forecastFoundation of supplierForecast.forecastFoundations) {
                    let expandedAmount = forecastFoundation.amounts[family.id]
                    if (expandedAmount > 0) {
                      supplierForecastData.push({
                        year: supplierForecast.year,
                        type: 'LINE_EXPANDED',
                        family: family,
                        field: forecastFoundation.field,
                        forecastFoundation: forecastFoundation,
                        amount: Math.round(expandedAmount)
                      })
                    }
                  }
                }
                supplierForecastData.push({
                  year: supplierForecast.year,
                  type: 'TOTAL',
                  family: '',
                  amount: totalAmount
                })

                this.supplierForecastDatas.push(supplierForecastData)
              }
            }
          }
          // console.log('Supplier field summary: ' + JSON.stringify(supplierFieldSummary, null, 2))

          if (supplierFieldSummary && supplierFieldSummary.forecastFoundations && supplierFieldSummary.forecastFoundations.length) {
            let foundations = supplierFieldSummary.forecastFoundations
            let lastAge = 0
            let lastYear = 0
            for (let foundation of foundations) {
              if (foundation.categories && foundation.categories.length) {
                for (let category of foundation.categories) {
                  this.supplierProductionForecastFoundations.push({
                    type: 'LINE',
                    age: foundation.age !== lastAge ? foundation.age : '',
                    // year: foundation.productionYear !== lastYear ? foundation.productionYear : '',
                    year: foundation.productionYear,
                    displayYear: foundation.productionYear !== lastYear,
                    category: category.displayLabel,
                    amount: foundation.categoryAmounts[category.id],
                    unitPrice: foundation.unitPrices[category.id],
                    price: foundation.prices[category.id]
                  })
                  lastAge = foundation.age
                  lastYear = foundation.productionYear
                }
              }
            }
          }

          this.supplierFieldSummaryReady = true
        })
        .catch((error) => {
          console.log('Failed to get supplier field summary: ' + error)
        })
    },
    async selectField (field) {
      await this.loadFieldSummary(field)
    },
    async loadFieldSummary (field = null, reload = false) {
      if (!field) {
        field = this.currentField
      }
      if (!reload) {
        this.fieldSummaryReady = false
        this.fieldSummary = null
        this.fieldProductionForecastFoundations = []
        this.fieldProductionCategoryForecastFoundations = []
        this.fieldForecastData = null
      }

      await axios.get('/backend/rest/field/summary/' + field.id)
        .then(response => {
          this.fieldSummary = response.data
          this.fieldPlanting = this.fieldSummary.planting
          let fieldSize = this.fieldPlanting ? this.fieldPlanting.size : 0

          let forecasts = this.fieldSummary.forecasts
          if (forecasts && forecasts.length) {
            this.fieldForecastData = null

            for (let forecast of forecasts) {
              let year = forecast.year
              let remainingAmounts = this.fieldPlanting && this.fieldPlanting.remainings ? this.fieldPlanting.remainings.filter(r => Number(r.production.name) === year) : null
              let remainingAmount = remainingAmounts && remainingAmounts.length ? remainingAmounts[0].amount : 0

              if (forecast && forecast.families && forecast.families.length) {
                let fieldForecastData = []
                let totalForecastAmount = 0
                let totalAmount = 0
                let totalForecastPercent = 0
                let totalPercent = 0
                for (let family of forecast.families) {
                  let overrideFamily = false
                  for (let f of forecast.overrides) {
                    if (f.id === family.id) {
                      overrideFamily = true
                      break
                    }
                  }
                  let removedFamily = false
                  for (let f of forecast.removed) {
                    if (f.id === family.id) {
                      removedFamily = true
                      break
                    }
                  }
                  let foundationCount = 0
                  for (let forecastFoundation of forecast.forecastFoundations) {
                    let expandedAmount = forecastFoundation.amounts[family.id]
                    if (expandedAmount >= 0) {
                      foundationCount++
                    }
                  }

                  let forecastAmount = forecast.forecastAmounts[family.id]
                  let amount = forecast.amounts[family.id]
                  let addedFamily = !(forecastAmount) && amount
                  let hiddenFamily = (!forecastAmount || forecastAmount === 0 || removedFamily) && !addedFamily
                  fieldForecastData.push({
                    year: forecast.year,
                    type: 'LINE',
                    family: family,
                    forecastAmount: Math.round(forecastAmount),
                    amount: Math.round(amount),
                    amountPerHa: Math.round(fieldSize ? amount / fieldSize : 0),
                    percentage: remainingAmount ? amount * 100 / remainingAmount : 0,
                    forecastDistribution: forecast.forecastDistributions[family.id],
                    distribution: forecast.distributions[family.id],
                    foundationCount: foundationCount,
                    override: overrideFamily,
                    removed: removedFamily,
                    hidden: hiddenFamily,
                    added: addedFamily
                  })
                  totalForecastAmount += Math.round(forecastAmount)
                  totalAmount += Math.round(amount)
                  totalForecastPercent += (remainingAmount ? forecastAmount * 100 / remainingAmount : 0)
                  totalPercent += (remainingAmount ? amount * 100 / remainingAmount : 0)
                }
                fieldForecastData.push({
                  type: 'TOTAL',
                  family: '',
                  forecastAmount: totalForecastAmount,
                  amount: totalAmount,
                  amountPerHa: '',
                  forecastPercentage: totalForecastPercent,
                  percentage: totalPercent,
                  override: forecast.totalOverride
                })

                this.fieldForecastData = fieldForecastData
                break
              }
            }
            this.currentField = field
            this.fieldSummaryReady = true
          } else {
            this.currentField = null
            this.showMessage('The field has no forecast')
          }
        })
        .catch((error) => {
          console.log('Failed to get field summary: ' + error)
        })
    },
    showMessage (message) {
      this.snackbarMessage = message
      this.snackbar = true
    },
    showForecastData (fieldForecastData) {
      return !fieldForecastData.hidden
    },
    canRemoveFamily (fieldForecastData) {
      return Number(this.activeProductionName) === fieldForecastData.year && !fieldForecastData.override && !fieldForecastData.removed && fieldForecastData.forecastAmount
    },
    canRestoreFamily (fieldForecastData) {
      return Number(this.activeProductionName) === fieldForecastData.year && fieldForecastData.removed
    },
    async removeFamily (fieldForecastData) {
      let forecastOverride = {
        production: this.$store.getters['session/getActiveProduction'],
        field: this.currentField,
        family: fieldForecastData.family,
        amount: 0,
        removed: true
      }

      await axios.post('/backend/rest/forecast/override', forecastOverride)
        .catch(error => {
          console.log(error.response.data)
          // this.errorTitle = error.response.data.title
          // this.errorMessage = error.response.data.message
          // this.errorDialog = true
        })

      await this.loadFieldSummary(this.currentField, true)
      await this.loadSupplierFieldSummary()
    },
    async restoreFamily (fieldForecastData) {
      let production = this.$store.getters['session/getActiveProduction']
      let field = this.currentField
      await axios.delete('/backend/rest/forecast/override/' + production.id + '/' + field.id + '/' + fieldForecastData.family.id)
        .catch(error => {
          console.log(error.response.data)
          // this.errorTitle = error.response.data.title
          // this.errorMessage = error.response.data.message
          // this.errorDialog = true
        })

      await this.loadFieldSummary(this.currentField, true)
      await this.loadSupplierFieldSummary()
    },
    hasAmountAdjustment (fieldForecastData) {
      let adjustment = this.getAdjustment(fieldForecastData)
      return adjustment != null && ((adjustment.amount && adjustment.amount >= 0) || adjustment.disabled)
    },
    getAdjustment (fieldForecastData) {
      if (fieldForecastData) {
        return fieldForecastData.forecastFoundation && fieldForecastData.forecastFoundation.adjustments && fieldForecastData.forecastFoundation.adjustments[fieldForecastData.family.id]
      }
      return null
    },
    getUtilization (amount) {
      let utilization = 0
      if (amount && this.fieldSummary && this.fieldSummary.amountRemaining) {
        utilization = 100 * amount / this.fieldSummary.amountRemaining
      }
      return utilization.toFixed(1) + '%'
    },
    createOrEditForecastOverride (fieldForecastData) {
      if (Number(this.activeProductionName) === fieldForecastData.year) {
        this.forecastOverrideDeletable = fieldForecastData.override || fieldForecastData.removed
        this.forecastOverride = {
          production: this.$store.getters['session/getActiveProduction'],
          field: this.currentField,
          family: fieldForecastData.family,
          amount: fieldForecastData.amount
        }

        console.log('Open dialog')
        this.forecastOverrideDialog = true
      }
    },
    async saveForecastOverride () {
      this.forecastOverrideDialog = false

      await axios.post('/backend/rest/forecast/override', this.forecastOverride)
        .then(response => {
          this.forecastOverrideDialog = false
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })

      await this.loadFieldSummary(this.currentField, true)
      this.loadSupplierFieldSummary()
    },
    async deleteForecastOverride () {
      this.forecastOverrideDialog = false

      await axios.delete('/backend/rest/forecast/override/' + this.forecastOverride.production.id + '/' + this.forecastOverride.field.id + '/' + this.forecastOverride.family.id)
        .then(response => {
          this.forecastOverrideDialog = false
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })

      await this.loadFieldSummary(this.currentField, true)
      this.loadSupplierFieldSummary()
    },
    cancelForecastOverride () {
      this.forecastOverrideDialog = false
    },
    createOrEditForecastTotalOverride (fieldForecastData, mode = 'AMOUNT') {
      this.forecastTotalOverrideDeletable = fieldForecastData.override
      this.forecastTotalOverrideMode = mode
      this.forecastTotalOverride = {
        production: this.$store.getters['session/getActiveProduction'],
        field: this.currentField,
        family: null,
        amount: fieldForecastData.amount,
        pct: Number(100 * fieldForecastData.amount / this.fieldSummary.amountRemaining).toFixed(1)
      }
      this.forecastTotalOverrideDialog = true
    },
    async saveForecastTotalOverride () {
      this.forecastTotalOverrideDialog = false

      if (this.forecastTotalOverrideMode === 'PCT') {
        this.forecastTotalOverride.amount = this.fieldSummary.amountRemaining * this.forecastTotalOverride.pct / 100
      }
      delete this.forecastTotalOverride.pct

      await axios.post('/backend/rest/forecast/override', this.forecastTotalOverride)
        .then(response => {
          this.forecastTotalOverrideDialog = false
        })
        .catch(error => {
          console.log(error.response.data)
          // this.errorTitle = error.response.data.title
          // this.errorMessage = error.response.data.message
          // this.errorDialog = true
        })

      await this.loadFieldSummary(this.currentField, true)
      this.loadSupplierFieldSummary()
    },
    async deleteForecastTotalOverride () {
      this.forecastTotalOverrideDialog = false

      await axios.delete('/backend/rest/forecast/override/' + this.forecastTotalOverride.production.id + '/' + this.forecastTotalOverride.field.id + '/0')
        .then(response => {
          this.forecastTotalOverrideDialog = false
        })
        .catch(error => {
          console.log(error.response.data)
          // this.errorTitle = error.response.data.title
          // this.errorMessage = error.response.data.message
          // this.errorDialog = true
        })

      await this.loadFieldSummary(this.currentField, true)
      this.loadSupplierFieldSummary()
    },
    cancelForecastTotalOverride () {
      this.forecastTotalOverrideDialog = false
    },
    printFieldData () {
      let url = '/backend/print/supplierForecast.xhtml?supplierId=' + this.currentSupplier.id + '&allFields=' + this.showAllFields + '&title=Field forecast'
      window.open(url)
    }
  },
  watch: {
  }
}
</script>

<style scoped>
button {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.breadCrumb {
  height: 30px !important;
  padding: 0 20px !important;
  margin-right: 6px !important;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 15px !important;
}
.v-btn {
  border-radius: 12px;
}
.tablet .btnToggleFilter.v-btn {
  padding: 0 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Forecast.vue